const state = {
	curriculums: [],
	isCurriculumsReady: false
};
  

const mutations = {
	setCurriculums: (st, data) => (st.curriculums = data),
	setIsCurriculumsReady: (st,data) => (st.isCurriculumsReady = data)
};

const getters = {
  getEvents: st => st.states,
};

const actions = {
	setCurriculums({commit},payload){
		commit('setCurriculums',payload)
		commit('setIsCurriculumsReady',true)
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
